
import {useState} from 'components/Assistant/hooks/reducer';
import {Assistant} from 'components/Assistant/hooks/types';
import moment from 'moment-timezone';
import {useContextLocation} from 'pages/booking/components/useLocation';
import {calcRegion} from 'pages/booking/components/useLocation/calcRegion';
import {Configs} from 'pages/booking/components/useLocation/types';

import {useSendUser, Vars} from './query';

const extras = (loc: Configs): Vars['extras'] => {
	if (!loc.region) {
		const zone = moment.tz.guess();
		if (zone) {
			return {zone};
		}
		return;
	}

	// Validate user coords is in the right region
	if (loc.userCoords) {
		const check = calcRegion(loc.userCoords);
		if (check?.key === loc.region.key) {
			return {
				coords: loc.userCoords,
				zone: loc.region.zone,
			};
		}
	}

	return {
		coords: loc.coords,
		zone: loc.region.zone,
	};
};

export const useScheduler = (): Assistant => {
	const [state, dispatch] = useState();
	const [send] = useSendUser(dispatch);
	const {configs: loc} = useContextLocation();

	return {
		state,
		send: (message: string) => {
			const minNext = (state.counter || 0) + 1;
			const counter = Math.max(minNext, Number(new Date()));

			// Update our local reducer with our pending state
			dispatch({
				type: 'SEND',
				message,
				counter,
			});

			// Send an API query, need the latest to return to
			// update/resolve our API state
			send({
				context: {
					counter,
					slowQuery: 'super-slow',
				},
				variables: {
					id: state.id,
					message,
					extras: extras(loc),
				},
			});
		},
	};
};
